import { Grid } from '@mui/material';
import BannerVideo from '../components/home/BannerVideo';
import Services from '../components/home/Services';
import Benefits from '../components/home/Benefits';
import Statistics from '../components/home/Statistics';
import SelectedImagesGallery from '../components/home/SelectedImagesGallery';

const Home = () => {
	return (
		<Grid
			display={'grid'}
			gap={'80px'}
			marginBottom={'50px'}
		>
			<BannerVideo />
			<Services />
			<Statistics />
			<Benefits />
			<SelectedImagesGallery />
		</Grid>
	);
};

export default Home;
